import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { EmptyStateUniDriver } from './EmptyState.uni.driver';
import { ButtonUniDriver } from '@wix/design-system/dist/testkit/unidriver';

export function PremiumEmptyStateUniDriver(base: UniDriver, body: UniDriver) {
  const { getButton, getImage, ...rest } = EmptyStateUniDriver(base, body);

  return {
    ...rest,
    /**
     * Get empty state CTA button driver
     */
    getButton: () =>
      ButtonUniDriver(base.$(`[data-hook="empty-state-premium-button"]`), body),
    /**
     * Get empty state image
     */
    getImage: () => getImage('empty-state-premium-illustration'),
  };
}
